export interface Option {
  value: string;
  label: string;
  note: string;
  values: Array<string | number>;
  labels: string[];
  children: Option[];
}

export interface ServerData {
  code: string;
  name: string;
  note: string;
  children: ServerData[];
}

export interface SelectedType {
  value: string;
  labels: string[];
  customInput?: string;
}

export interface SelectedCache {
  value: string;
  label: string;
  values: Array<string | number>;
  labels: string[];
}

export interface SearchResult {
  value: string;
  label: string;
  values: string[];
  labels: string[];
  count: number;
}

export function buildOptionTree(data: ServerData[], parent: Option | null): Option[] {
  const result: Option[] = data.map((d) => {
    const res: Option = {
      value: d.code,
      label: d.name,
      note: d.note,
      values: [...(parent?.values || []), d.code],
      labels: [...(parent?.labels || []), d.name],
      children: [],
    };
    return { ...res, children: buildOptionTree(d.children, res) };
  });
  return result.length === 0 ? [] : result;
}
